import noTypedCamelCaseName from '@tinkoff/utils/string/camelCaseName';
export function camelCaseName(str) {
    return noTypedCamelCaseName(str);
}
//# sourceMappingURL=string.js.map